const DEFAULT_CONFIRMATS_SHOW_ETIQUETA = {
    TOTS: true,
    'FITXATS + ARRIBANT': true,
    FITXATS: false,
    ARRIBANT: false,
};

const DEFAULT_GENERIC_SHOW_ETIQUETA = {
    TOTS: true,
    FITXATS: true,
    'ESTAN ARRIBANT': true,
};

const normalizeListName = (listName) => String(listName || '').trim().toLowerCase();

const sanitizeStoredShowEtiqueta = (storedState) => {
    if (!storedState || typeof storedState !== 'object' || Array.isArray(storedState)) {
        return {};
    }

    return Object.fromEntries(
        Object.entries(storedState)
            .filter(([, value]) => typeof value === 'boolean')
    );
};

export const normalizePerfilKey = (listName, perfil) => {
    const normalizedPerfil = String(perfil || '').trim().toUpperCase();

    if (!normalizedPerfil) {
        return null;
    }

    if (normalizeListName(listName) === 'confirmats') {
        return normalizedPerfil === 'ESTAN ARRIBANT' ? 'ARRIBANT' : normalizedPerfil;
    }

    return normalizedPerfil === 'ARRIBANT' ? 'ESTAN ARRIBANT' : normalizedPerfil;
};

export const getShowEtiquetaStorageKey = (listName) => `pissarra_show_etiqueta_${normalizeListName(listName)}`;

export const getDefaultShowEtiqueta = (listName) => (
    normalizeListName(listName) === 'confirmats'
        ? { ...DEFAULT_CONFIRMATS_SHOW_ETIQUETA }
        : { ...DEFAULT_GENERIC_SHOW_ETIQUETA }
);

export const buildInitialShowEtiqueta = (listName, storedState) => ({
    ...getDefaultShowEtiqueta(listName),
    ...sanitizeStoredShowEtiqueta(storedState),
});

export const ensurePerfilVisible = (listName, previousState, perfil) => {
    const perfilKey = normalizePerfilKey(listName, perfil);
    const currentState = previousState || getDefaultShowEtiqueta(listName);

    if (normalizeListName(listName) === 'etiquetes' && perfilKey) {
        const defaultKeys = Object.keys(DEFAULT_GENERIC_SHOW_ETIQUETA);

        return Object.fromEntries(
            Object
                .entries({
                    ...currentState,
                    [perfilKey]: true,
                })
                .map(([key, value]) => [
                    key,
                    defaultKeys.includes(key) ? value : key === perfilKey,
                ])
        );
    }

    if (!perfilKey || currentState?.[perfilKey] === true) {
        return currentState;
    }

    return {
        ...currentState,
        [perfilKey]: true,
    };
};

export const togglePerfilVisibility = (listName, previousState, perfil) => {
    const perfilKey = normalizePerfilKey(listName, perfil);
    const currentState = previousState || getDefaultShowEtiqueta(listName);

    if (!perfilKey) {
        return currentState;
    }

    return {
        ...currentState,
        [perfilKey]: !currentState?.[perfilKey],
    };
};
